module.exports = __webpack_public_path__ + "img/gadvtar.26f5fdb2.png";